import React from 'react';
import Dropdown from 'src/ui/library/Dropdown';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import WithHeader from '../../wrappers/WithHeader';

class DropdownControl extends React.Component {
  state = {
    value: this.props.value || '',
  };

  static defaultProps = {
    listOptions: [],
  };

  componentDidMount() {
    let { listOptions } = this.props;
    if (
      listOptions &&
      listOptions.map(x => x.displayText).includes(this.state.value) &&
      !listOptions.map(x => x.lookUpBindValue).includes(this.state.value)
    ) {
      this.setState({ value: listOptions[listOptions.findIndex(x => x.displayText === this.state.value)].lookUpBindValue });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
    }
  }

  handleOnChange = event => {
    this.setState({ value: event.target.value });
    event.target.value = event.target.value ? event.target.value : '';
    this.props.onChange(event);
  };

  renderDropdown = () => {
    let { id, label, required, description, listOptions } = this.props;

    if (listOptions === null) listOptions = [{ lookUpBindValue: 'missingdata', displayText: 'Missing Data' }];

    const dropDownComp = (
      <Dropdown
        required={required}
        options={listOptions.map(item => ({ value: item.lookUpBindValue, label: item.displayText }))}
        id={id}
        name={id}
        label={label}
        value={this.state.value}
        onChange={this.handleOnChange}
      />
    );

    if (description) {
      return (
        <React.Fragment>
          <span className="control-label">{description}</span>
          {dropDownComp}
        </React.Fragment>
      );
    }

    return dropDownComp;
  };

  render() {
    const { helpText } = this.props;

    let component = this.renderDropdown();

    if (helpText) {
      component = <InfoTooltip toolTipText={helpText} labelText={component} className="dropdown-tooltip" />;
    }

    return component;
  }
}

export default WithHeader(DropdownControl);
